import React, { } from 'react'
import { InputAdornment, TextField } from '@material-ui/core';

const CustomData = ({ readonly, value, formik, name }) => {

    const options = [
        { key: "getijdenzone", label: "In getijdenzone" },
        { key: "ponten_boei", label: "Bij ponton of boei" },
        { key: "talud_rif", label: "Bij talud of rif onder getijdenzone" },
        { key: "wrak", label: "Bij het wrak" },
        { key: "bodem", label: "Op zand of slik bodem" }
    ]

    const getValue = (key) => {
        const lines = value.split(';')
        let retval= ''
        lines.every((line) => {
            const code = line.split(':')[0]
            if (code === key) {
                retval= line.split('=')[1]
                return false;
            }
            return true
        })
        return retval
    }

    const setValue = (key, value) => {
        const lines= []
        options.forEach(opt => {
            const newVal= (opt.key === key ? value : getValue(opt.key))
            const line= opt.key + ':"' + opt.label + '"=' + newVal
            lines.push(line)
        })
        formik.setFieldTouched(name, true)
        formik.setFieldValue(name, lines.join(';'))
    }

    return (
        options.map(item =>
                <TextField 
                    disabled={readonly} 
                    label={item.label}
                    variant="standard" 
                    name={item.key}
                    type="number" 
                    fullWidth  
                    value={getValue(item.key)}
                    onChange={(e)=>setValue(item.key, e.target.value)}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">min.</InputAdornment>
                    }}
                />
        ))
}
export default CustomData
